import { render, staticRenderFns } from "./BaseStaticPage.vue?vue&type=template&id=260f4f7e&scoped=true&"
import script from "./BaseStaticPage.vue?vue&type=script&lang=js&"
export * from "./BaseStaticPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseStaticPage.vue?vue&type=style&index=0&id=260f4f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f4f7e",
  null
  
)

export default component.exports